<form>
    <div class="row no-gutters content_top_margin">
        <div class="col-12">
            <fieldset aria-required="true" aria-labelledby="lblCoApplicantScreen">
                <legend role="radiogroup" id="lblCoApplicantScreen"
                    class="bot_spa_aft_sect_heading legend_display sectionHeading_one">
                    <ng-container *ngIf="flowType?.type ==='P'">
                        {{'co-applicant-selection.titleTextBox' | translate }}
                    </ng-container>
                    <ng-container *ngIf="flowType?.type ==='S'">
                        {{'co-applicant-selection.switchTitleTextBox' | translate }}
                    </ng-container>
                </legend>
                <div class="row no-gutters">
                    <div class="col-12 d-md-inline-flex">
                        <div>
                            <label [class]="borderColorY ? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' :
                                 displayValidation ? 'validationBorder d-flex radio_button_border  field_lable_bot_margin_unset':
                                 'nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                <div class="nobtn"
                                    [ngClass]="(borderColorY && selectionY != null) ? 'cst-rd-check':'cst-rd'">
                                    <input tabindex="0" id="yesRadio" aria-describedby="errMsg" id="yes"
                                        [attr.aria-checked]="selectionY" class="radioPosition" type="radio" name="alpha"
                                        [checked]="selectionY" (click)="buttonDisplay('yes')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span class="spanPosition radioSpan ml-2">
                                    {{ 'co-applicant-selection.yes' | translate }}
                                </span>
                            </label>
                        </div>
                        <div class="space_between_field">
                            <label
                                [class]="borderColorN ? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' : displayValidation ? 'validationBorder d-flex radio_button_border  field_lable_bot_margin_unset':'nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                <div class="nobtn" [ngClass]="(!borderColorY && selectionY != null) ? 'cst-rd-check':'cst-rd'">
                                    <input tabindex="0" aria-describedby="errMsg" id="no" style="width:0px !important;"
                                        [attr.aria-checked]="selectionN" class="radioPosition" type="radio" name="alpha" [checked]="selectionN"
                                        (click)="buttonDisplay('no')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span class="spanPosition radioSpan ml-2">
                                    {{ 'co-applicant-selection.no' | translate }}
                                </span>
                            </label>
                        </div>
                    </div>
                  
                </div>
            </fieldset>
            <div class="row no-gutters top_spa_aft_sect_heading">
                <div class="col-12" [ngClass]="displayValidation ? 'd-flex align-items-center errorMsg' : 'd-none'" id="errMsg">
                    <img aria-hidden="true" src="./assets/images/menu_icons/Alert.svg" alt="">
                    <span class="ml-2">{{ 'co-applicant-selection.validation' | translate
                        }}</span>
                </div>
            </div>
            <ng-container *ngIf="coApplicantSelectionObj.isCoApplicantPresent == 'Y'">
                <div class="row no-gutters top_spa_aft_sect_heading">
                    <div class="col-12" role="alert" aria-atomic="true" aria-live="polite">
                        <span id="prequalSingleBorrContent">
                            <ng-container *ngIf="flowType?.type=='P'">
                                {{ 'coApplicantSelection.tooltipCoApplicant' | translate }}
                            </ng-container>
                            <ng-container *ngIf="flowType?.type ==='S'">
                                {{ 'coApplicantSelection.tooltipCoApplicantSwitch' | translate }}
                            </ng-container>
                        </span>
                    </div>
                </div>
            </ng-container>
            <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
                <div class="col-12  d-md-block d-flex  flex-column-reverse">
                    <cancel-button></cancel-button>
                    <button type="button" class="common_btn saveNextBtn_features space_between_button"
                        (click)="onSubmit()">{{'buttonallpages.continuelable' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</form>